import { useCallback, useState } from 'react';

export const useChatMessages = () => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = useCallback(async (content, attachments = []) => {
    const userMessage = {
      id: `msg-${Date.now()}`,
      role: 'user',
      content,
      timestamp: new Date(),
      attachments: attachments.length > 0 ? [...attachments] : undefined,
    };

    setMessages((prev) => [...prev, userMessage]);

    setIsLoading(true);

    // Simulate AI processing
    await new Promise((resolve) => setTimeout(resolve, 1500));

    const fileCount = attachments.length;
    const responseContent =
      fileCount > 0
        ? `I received your message${content ? `: "${content}"` : ''} with ${fileCount} file${fileCount > 1 ? 's' : ''} attached. This is a simulated response from the AI assistant. In a real application, I would process these files.`
        : `I received your message: "${content}". This is a simulated response from the AI assistant. In a real application, this would connect to an actual AI service.`;

    const aiMessage = {
      id: `msg-${Date.now()}`,
      role: 'assistant',
      content: responseContent,
      timestamp: new Date(),
    };

    setMessages((prev) => [...prev, aiMessage]);
    setIsLoading(false);
  }, []);

  return {
    messages,
    isLoading,
    sendMessage,
  };
};
